export default "__VITE_ASSET__C6lFqTh8__"